import {
  Box,
  PlacementWithLogical,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

import { TopDetectionEntitiesTablePopperContent } from './TopDetectionEntitiesTablePopperContent';
import { DetectionSummary } from '@investigator/shared/generated/graphql';

export const TopDetectionEntitiesTablePopper = (
  placement: PlacementWithLogical = 'right-start',
) => {
  return ({
    children,
    ...rest
  }: DetectionSummary & { children: ReactNode }) => {
    return (
      <Popover isLazy trigger="hover" openDelay={300} placement={placement}>
        <PopoverTrigger>
          <Box data-testid="top-entities-table-popper-trigger" role="button">
            {children}
          </Box>
        </PopoverTrigger>
        <PopoverContent
          w="500px"
          _focus={{
            outline: 'none',
            boxShadow: 'none',
          }}
        >
          <TopDetectionEntitiesTablePopperContent {...rest} />
        </PopoverContent>
      </Popover>
    );
  };
};
